import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fileUrl = (path) => {
  if (!path) return null;
  return `${API}/files/${path}`;
};

export const listProducts = async (category) => {
  const res = await api.get("/products", { params: category && category !== "all" ? { category } : {} });
  return res.data;
};

export const getProduct = async (id) => (await api.get(`/products/${id}`)).data;

export const farmerLogin = async (payload) => (await api.post("/auth/farmer-login", payload)).data;
export const adminLogin = async (payload) => (await api.post("/auth/admin-login", payload)).data;

export const createOrder = async (payload) => (await api.post("/orders", payload)).data;
export const listOrdersForFarmer = async (farmerId) => (await api.get("/orders", { params: { farmer_id: farmerId } })).data;
export const getOrder = async (id) => (await api.get(`/orders/${id}`)).data;

const adminHeaders = (token) => ({ headers: { "X-Admin-Token": token } });
export const adminListOrders = async (token, status) => (await api.get("/orders", { params: { admin: true, status: status || undefined }, ...adminHeaders(token) })).data;
export const adminUpdateOrderStatus = async (token, id, status) => (await api.put(`/orders/${id}/status`, { status }, adminHeaders(token))).data;
export const adminStats = async (token) => (await api.get("/orders/stats", adminHeaders(token))).data;
export const adminAnalytics = async (token) => (await api.get("/orders/analytics", adminHeaders(token))).data;
export const adminCreateProduct = async (token, payload) => (await api.post("/products", payload, adminHeaders(token))).data;
export const adminUpdateProduct = async (token, id, payload) => (await api.put(`/products/${id}`, payload, adminHeaders(token))).data;
export const adminDeleteProduct = async (token, id) => (await api.delete(`/products/${id}`, adminHeaders(token))).data;
export const adminUploadImage = async (token, file) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post("/upload", fd, {
    headers: { "X-Admin-Token": token, "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getCategories = async () => (await api.get("/categories")).data;

export const getSettings = async () => (await api.get("/settings")).data;
export const adminUpdateSettings = async (token, payload) => (await api.put("/settings", payload, adminHeaders(token))).data;
export const adminChangeCredentials = async (token, payload) =>
  (await api.put("/auth/admin-credentials", payload, adminHeaders(token))).data;
export const adminEmergencyReset = async (recoveryCode) =>
  (await api.post("/auth/admin-emergency-reset", { recovery_code: recoveryCode })).data;

// Build a WhatsApp click-to-chat URL. `phone` may include country code (digits only).
export const whatsappUrl = (phone, text) => {
  const p = (phone || "").replace(/\D/g, "");
  const encoded = encodeURIComponent(text || "");
  return `https://wa.me/${p}?text=${encoded}`;
};

// Build message body for a new order (owner-facing)
export const buildOrderWhatsAppText = (order, langHi = true) => {
  const L = langHi
    ? { hdr: "🌾 नया ऑर्डर - कृषिदूत ट्रेडिंग", num: "ऑर्डर नं", from: "ग्राहक", mob: "मोबाइल", addr: "पता", items: "आइटम", total: "कुल", notes: "नोट" }
    : { hdr: "🌾 New Order - Krishidut Trading", num: "Order No", from: "Customer", mob: "Mobile", addr: "Address", items: "Items", total: "Total", notes: "Notes" };
  const itemLines = order.items.map((it) => {
    const name = langHi ? it.name_hi : it.name_en;
    return `• ${name} — ${it.quantity} × ₹${it.price.toFixed(0)} = ₹${(it.quantity * it.price).toFixed(0)}`;
  }).join("\n");
  const notesLine = order.notes ? `\n${L.notes}: ${order.notes}` : "";
  return (
    `*${L.hdr}*\n\n` +
    `${L.num}: ${order.order_number}\n` +
    `${L.from}: ${order.delivery_name}\n` +
    `${L.mob}: ${order.delivery_mobile}\n` +
    `${L.addr}: ${order.delivery_address}${notesLine}\n\n` +
    `*${L.items}:*\n${itemLines}\n\n` +
    `*${L.total}: ₹${order.total.toFixed(0)}* (COD)`
  );
};
